import axios from 'axios';

export const configureContentTypeJson = () => {
    axios.interceptors.request.use(config => {
        config.headers['Content-Type'] = 'application/json';
        return config;
    }, error => {
        Promise.reject(error)
    })
}